<div class="container">
  <app-ml-model-toolbar></app-ml-model-toolbar>
</div>
<div class="container">
  <div [@routeAnimations]="prepareRoute(outlet)">
    <router-outlet #outlet="outlet"></router-outlet>
</div>

<app-ml-footer></app-ml-footer>